const getToggledClassName = isToggled => {
  return isToggled
    ? '!text-primary'
    : '!text-common-bright dark:hover:!bg-primary-newgray hover:!bg-primary-gray hover:text-primary-light';
};

export { getToggledClassName };
